import { render, staticRenderFns } from "./NewTBConclusion.vue?vue&type=template&id=3eb0f9a2&scoped=true"
import script from "./NewTBConclusion.vue?vue&type=script&lang=js"
export * from "./NewTBConclusion.vue?vue&type=script&lang=js"
import style0 from "./NewTBConclusion.vue?vue&type=style&index=0&id=3eb0f9a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb0f9a2",
  null
  
)

export default component.exports